/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopOffersContainer_lists$ref = any;
export type ReorderTopOffersInput = {|
  clientMutationId?: ?string,
  ids: $ReadOnlyArray<string>,
|};
export type reorderTopOffersMutationVariables = {|
  input: ReorderTopOffersInput
|};
export type reorderTopOffersMutationResponse = {|
  +reorderTopOffers: ?{|
    +lists: {|
      +$fragmentRefs: TopOffersContainer_lists$ref
    |}
  |}
|};
export type reorderTopOffersMutation = {|
  variables: reorderTopOffersMutationVariables,
  response: reorderTopOffersMutationResponse,
|};
*/


/*
mutation reorderTopOffersMutation(
  $input: ReorderTopOffersInput!
) {
  reorderTopOffers(input: $input) {
    lists {
      ...TopOffersContainer_lists
      id
    }
  }
}

fragment TopOfferCell_offer on Offer {
  id
  title
  startDate
  endDate
  store {
    name
    id
  }
}

fragment TopOffersContainer_lists on Lists {
  topOffers(first: 50) {
    edges {
      node {
        id
        ...TopOfferCell_offer
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ReorderTopOffersInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reorderTopOffersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderTopOffersPayload",
        "kind": "LinkedField",
        "name": "reorderTopOffers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopOffersContainer_lists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reorderTopOffersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderTopOffersPayload",
        "kind": "LinkedField",
        "name": "reorderTopOffers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 50
                  }
                ],
                "concreteType": "OfferConnection",
                "kind": "LinkedField",
                "name": "topOffers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfferEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Offer",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Store",
                            "kind": "LinkedField",
                            "name": "store",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "topOffers(first:50)"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "reorderTopOffersMutation",
    "operationKind": "mutation",
    "text": "mutation reorderTopOffersMutation(\n  $input: ReorderTopOffersInput!\n) {\n  reorderTopOffers(input: $input) {\n    lists {\n      ...TopOffersContainer_lists\n      id\n    }\n  }\n}\n\nfragment TopOfferCell_offer on Offer {\n  id\n  title\n  startDate\n  endDate\n  store {\n    name\n    id\n  }\n}\n\nfragment TopOffersContainer_lists on Lists {\n  topOffers(first: 50) {\n    edges {\n      node {\n        id\n        ...TopOfferCell_offer\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cc31682ea36f2dae439360fc0e294999';

module.exports = node;
